export const DEFAULT_PROFILE = 'profile_0';

export enum LayoutType {
  MAIN = 'MAIN',
  EMPTY = 'EMPTY',
  LANDING = 'LANDING',
}

export enum Fonts {
  TEXT = 'SF Pro Text',
  TITLE = 'SF Pro Display',
  LATO = 'Lato',
  ABC_ORACLE = 'ABC Oracle',
}

export enum QueryKey {
  INIT_SESSION = 'init-session',
  USER_DATA = 'user-data',
  USER_PRODUCTS = 'user-products',
  CONTENT_PLAN = 'content-plan',
  USER_PROGRESS = 'user-progress',
  USER_GUIDE = 'user-guide',
  BUY_GUIDE = 'buy-guide',
  USER_SUBSCRIPTION_INFO = 'user-subscription-info',
  CHANGE_PASSWORD = 'change-password',
  SIGN_IN = 'sign-in',
  RENEW_SUBSCRIPTION = 'renew-subscription',
  SET_NEW_MEET = 'set-new-meet',
  ONBOARDING = 'onboarding',
  INTERVIEW_OFFER = 'interview-offer',
  PAID_OPTIONS_STATUS = 'paid-options-status',
  LAST_USER_SESSION = 'last-user-session',
  EDIT_MEET = 'edit-meet',
  CHARGE_REMINDER = 'charge-reminder',
  UNSUBSCRIBE_AB_TEST = 'unsubscribe-ab-test',
  FIREBASE_REMOTE_CONFIG = 'firebase-remote-config',
  BUY_UPSELL = 'buy-upsell',
  SET_SESSION_LIMIT = 'set-session-limit',
  USER_SESSION_LIMIT = 'session-limit',
  SESSION_CONTENT = 'session-content',
  SUBSCRIPTION_DISCOUNTS = 'subscription-discounts',
  USER_SUBSCRIPTIONS_INFO = 'user-subscriptions-info',
  SUBSCRIPTION_PAUSE = 'subscription-pause',
  ARTICLE = 'article',
  HIGHLIGHTS = 'highlights',
  STYLE_ARTICLE = 'style-article',
  LEGAL_SENTENCE = 'legal-sentence',
  USER_PHOTO = 'user-photo',
  OUTFIT = 'outfit',
  SAVED_OUTFITS = 'saved-outfits',
  LIKE_OUTFIT = 'like-outfit',
  CONFIG = 'config',
  SIGN_UP = 'sign-up',
  USER_MEMBERSHIP = 'user-membership',
  USER_MEMBERSHIP_PROMOCODES = 'user-membership-promocodes',
  CONTENT_MEMBERSHIP_V2 = 'content-membership-v2',
  STYLIST = 'stylist',
  SET_MAX_MEMBERSHIP_LEVEL = 'set-max-membership-level',
  CREATE_TRUSTPILOT_INVITATION_LINK = 'create-trustpilot-invitation-link',
  ARTICLES = 'articles',
  COLLECTIONS = 'collections',
  CATEGORIES = 'categories',
  HOME_INSIGHTS_CATEGORIES = 'home-insights-categories',
  TAGS = 'tags',
  BOOKMARKS = 'bookmarks',
  ADD_BOOKMARK = 'add-bookmark',
  REMOVE_BOOKMARK = 'remove-bookmark',
  BOOKMARKED_ARTICLES = 'bookmarked-articles',
  BOOKMARKED_COLLECTIONS = 'bookmarked-collections',
  ARTICLE_LIKES = 'article-likes',
  ADD_ARTICLE_LIKE = 'add-article-like',
  REMOVE_ARTICLE_LIKE = 'remove-article-like',
  ADD_ARTICLE_DISLIKE = 'add-article-dislike',
  REMOVE_ARTICLE_DISLIKE = 'remove-article-dislike',
  STYLING_JOURNEY = 'styling-journey',
  JOURNEY_COMPLETED_STEPS = 'journey-completed-steps',
}

export enum ProductNameDiscount {
  PREMIUM = '39ad6435-e720-4240-9ad8-fb1086aa28e5',
  ONE_MONTH_FREE = '55b38017-c1e6-4503-9caa-e920ce4f3772',
}

export enum UserSource {
  WEB = 'web',
  IOS = 'ios',
  POLICY = 'policy',
}

export enum FirebaseCollection {
  USER_PROFILE_MAPPING = 'userProfileMapping',
}

export enum FirebaseType {
  LUMI = 'lumi',
  TITLE = 'title',
}

export type TCloudinaryResponse = {
  asset_id?: string;
  public_id?: string;
  version?: number;
  version_id?: string;
  signature?: string;
  width?: number;
  height?: number;
  format?: string;
  resource_type?: string;
  created_at?: string;
  tags?: string[];
  bytes?: number;
  type?: string;
  etag?: string;
  placeholder?: boolean;
  url?: string;
  secure_url?: string;
  original_filename?: string;
};
